import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RupeePaisePipe } from "app/main/shared/pipes/paise-to-rupee.pipe";

@Component({
  selector: "app-charge-weight-details",
  templateUrl: "./charge-weight-details.component.html",
  styleUrls: [
    "./charge-weight-details.component.scss",
    "../../../../../scss/responsive-modals.scss"
  ],
  encapsulation: ViewEncapsulation.None
})
export class ChargeWeightDetailsComponent implements OnInit {
  price: any = {};
  basePrice: number | string;
  codServiceCost: number | string;
  fullPrice: number | string;
  reverseBasePrice: number | string;
  reverseGSTPrice: number | string;

  rupeePaisePipe = new RupeePaisePipe();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.price = this.data?.details?.price;
    const prices = this.price;

    this.basePrice = prices?.breakdown
      ? this.rupeePaisePipe?.transform(prices?.breakdown?.basePrice, "rupee")
      : "0.00";

    this.reverseBasePrice = prices?.breakdown
      ? this.rupeePaisePipe?.transform(prices?.breakdown?.reverse_base, "rupee")
      : "0.00";

    this.codServiceCost = prices?.CodServiceCost
      ? this.rupeePaisePipe?.transform(prices?.CodServiceCost, "rupee")
      : "0.00";

    this.reverseGSTPrice = prices?.breakdown
      ? this.rupeePaisePipe?.transform(prices?.breakdown?.reverse_gst, "rupee")
      : "0.00";

    this.fullPrice = prices?.price
      ? this.rupeePaisePipe?.transform(prices?.price, "rupee")
      : "0.00";
  }
}
